import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Btn } from '../../AbstractElements';
import { AddPayment, AddPayments, Cancel, LogOut, Print, ThermalPrint, key, key_secret, share } from '../../Constant';
import ItemDescription from './ItemDescription';
import { Col, Spinner } from 'reactstrap';
import { useReactToPrint } from 'react-to-print';
import { useLocation, useNavigate } from 'react-router';
import Transparentspinner from "../Common/Loader/Transparentspinner";
import { getGeneratePayment, getInvoice, getMakePayment, getPackageDet } from '../../CommonUrl';
import * as authServices from "../../Utils/authServices";
import { getMasterDataToken, postDataWithoutResData, postMasterToken } from '../../Utils/restUtils';
import { toast } from 'react-toastify';
import NavSign from '../../Billerq/Sign/NavSign';
import Popup from '../Common/Popup/popup';
import { PayPalButtons } from '@paypal/react-paypal-js';
import HandleHomePageError from '../Common/ErrorImport/SignError';
import '../../Billerq/Subscription/ApplyCoupon.css';

const PrintComponent = () => {
    const location = useLocation();
    const searchParams = location.search;
    const [loading, setLoading] = useState(false)
    const params = new URLSearchParams(searchParams);
    const userId = params.get("order_id");
    const [invoiceDetail, setInvoiceDetail] = useState({});
    const [statusColor, setStatusColor] = useState('');
    const navigate = useNavigate();
    const [skipValue, setSkipValue] = useState('');
    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // Modal and payment selection state
    const [modal, setModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [paymentGateways, setPaymentGateways] = useState([]);
    const [fetchingGateways, setFetchingGateways] = useState(false);

    useEffect(() => {
        getInvoiceData();
        getPackage();
    }, [])

    useEffect(() => {
        if (modal) {
            getGateways();
        }
    }, [modal]);

    const getGateways = async () => {
        setFetchingGateways(true);
        try {
            const response = await getMasterDataToken("payment-gateways");
            if (response && response.status === true && Array.isArray(response.data)) {
                setPaymentGateways(response.data);
                if (response.data.length > 0) {
                    const hasRazorPay = response.data.some(gw => gw.code === 'razorpay');
                    setPaymentMethod(hasRazorPay ? 'razorpay' : response.data[0].code);
                }
            } else {
                setPaymentGateways([
                    { id: 1, name: "razorPay", code: "razorpay" },
                    { id: 2, name: "PayPal", code: "paypal" }
                ]);
                setPaymentMethod('razorpay');
            }
        } catch (error) {
            console.error(error);
            setPaymentGateways([
                { id: 1, name: "razorPay", code: "razorpay" },
                { id: 2, name: "PayPal", code: "paypal" }
            ]);
            setPaymentMethod('razorpay');
        } finally {
            setFetchingGateways(false);
        }
    };

    const getPackage = async () => {
        const response = await getMasterDataToken(getPackageDet);
        if (response.status === true) {
            const packagetDetails = response.data;
            setSkipValue(packagetDetails);
        } else {
            HandleHomePageError(navigate, response.status)
        }
    }

    const navigateDashboard = () => {
        const dashbaord = `${process.env.PUBLIC_URL}/dashboard/default`;
        navigate(dashbaord);
    };

    const getInvoiceData = async () => {
        setLoading(true)
        const data = await postDataWithoutResData(getInvoice + `/${userId}`);
        if (data.status === 200) {
            setInvoiceDetail(data.data.data);
            if (data.data.data.payment_status === "pending") {
                setStatusColor('#dc0808');
            } else if (data.data.data.payment_status === 'paid') {
                setStatusColor('#67c100');
            } else if (data.data.data.payment_status === 'paschal') {
                setStatusColor('#e56809');
            } else {
                setStatusColor('#5F0F40');
            }
        }
        setLoading(false)
    }

    const handleRazorpayPayment = async () => {
        setLoading(true);
        const result = await postMasterToken(getGeneratePayment, { order_id: userId });
        if (result.status === 200) {
            if (result.data.status === true) {
                const { id: orderId, email: email, name: name, mobile: mobile, amount: amount, currency: currency } = result.data.data;
                if (amount === "") {
                    alert("please enter amount");
                } else {
                    var options = {
                        key: key,
                        key_secret: key_secret,
                        amount: amount.toString(),
                        currency: currency,
                        name: "BillerQ",
                        description: "for payment purpose",
                        order_id: orderId,
                        handler: async function (response) {
                            const data = {
                                orderCreationId: orderId,
                                razorpayPaymentId: response.razorpay_payment_id,
                                razorpayOrderId: response.razorpay_order_id,
                                razorpaySignature: response.razorpay_signature,
                            };
                            setLoading(true);
                            let payment = await postMasterToken(getMakePayment, data);
                            if (payment.status === 200) {
                                if (payment.data.status === true) {
                                    toast.success(payment.data.message);
                                    getInvoiceData();
                                    setModal(false);
                                    navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
                                    setLoading(false);
                                } else {
                                    toast.error(payment.data.message);
                                    setLoading(false);
                                }
                            }
                        },
                        prefill: {
                            name: name,
                            email: email,
                            contact: mobile
                        },
                        notes: {
                            address: "Razorpay Corporate office"
                        },
                        theme: {
                            color: "#3399cc"
                        }
                    };
                    var pay = new window.Razorpay(options);
                    pay.open();
                }
            } else {
                toast.error(result.data.message);
                setLoading(false);
            }
        }
        setLoading(false);
    }

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <NavSign showProfile={true} buttonText={LogOut} />

            <div className='bg-light pt-5' style={{ height: '100%' }}>
                <ItemDescription
                    ref={componentRef}
                    idValue={invoiceDetail}
                    statusColor={statusColor}
                />
                <Col sm="12" className="text-center mb-3">
                    <Btn attrBtn={{ color: 'primary', className: 'me-2', onClick: handlePrint }}>
                        Print
                    </Btn>
                    {invoiceDetail.payment_status !== 'paid' && (
                        <Btn attrBtn={{ color: 'danger', className: 'me-2', onClick: () => setModal(true) }}>
                            {AddPayment}
                        </Btn>
                    )}
                    {skipValue.skip === true && (
                        <Btn attrBtn={{ color: 'primary', className: 'me-2', onClick: () => navigateDashboard() }}>
                            Skip
                        </Btn>
                    )}
                </Col>
            </div>

            <Popup isOpen={modal} title="Select Payment Method" toggler={() => setModal(false)} size="md">
                {fetchingGateways && (
                    <Transparentspinner />

                )}
                <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                    <div className="payment-methods-group">
                        {paymentGateways.map((gateway) => {
                            const isSelected = paymentMethod === gateway.code;
                            return (
                                <div
                                    key={gateway.id}
                                    className={`payment-method-card  ${isSelected ? 'selected' : ''}`}
                                    onClick={() => setPaymentMethod(gateway.code)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="payment-method-left">
                                        <input
                                            type="radio"
                                            name="payment_method"
                                            className="payment-method-radio"
                                            checked={isSelected}
                                            onChange={() => setPaymentMethod(gateway.code)}
                                        />
                                        <span className="payment-method-label text-capitalize">
                                            {gateway.code === 'razorpay' ? 'razorPay' : gateway.name}
                                        </span>
                                    </div>
                                    <div className="payment-method-logo">
                                        {gateway.code === 'paypal' ? (
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M20.07 6.46C20.07 3.32 17.68 1 13.9 1H6.18C5.45 1 4.83 1.5 4.7 2.22L1.08 21.05C1 21.46 1.32 21.82 1.74 21.82H6.96C7.69 21.82 8.31 21.32 8.44 20.6L9.62 14.5L10 12.5C10.13 11.78 10.75 11.28 11.48 11.28H13.62C17.4 11.28 19.98 9.38 20.07 6.46Z" fill="#003087" />
                                                <path d="M16.92 9.46C16.92 6.32 14.53 4 10.75 4H3.03C2.3 4 1.68 4.5 1.55 5.22L0.08 14.73C-0.07 15.68 0.67 16.5 1.63 16.5H5.82L7 10.4L7.38 8.4C7.51 7.68 8.13 7.18 8.86 7.18H11C14.78 7.18 17.36 5.28 17.45 2.36C17.26 5.86 14.88 9.46 16.92 9.46Z" fill="#0079C1" />
                                            </svg>
                                        ) : gateway.code === 'razorpay' ? (
                                            <span style={{ fontWeight: '700', color: '#1e40af', fontSize: '13px' }}>Razorpay</span>
                                        ) : (
                                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="2" y="5" width="20" height="14" rx="2" ry="2" />
                                                <line x1="2" y1="10" x2="22" y2="10" />
                                            </svg>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {paymentMethod === 'paypal' ? (
                        <div className="pay-now-btn-container">
                            <PayPalButtons
                                style={{
                                    layout: "vertical",
                                    color: "blue",
                                    shape: "rect",
                                    label: "pay",
                                    height: 48,
                                }}
                                createOrder={async () => {
                                    setFetchingGateways(true);
                                    try {
                                        const response = await postMasterToken("paypal/create-order", {
                                            order_id: invoiceDetail?.order_id,
                                        });
                                        if (response && response.status === 200 && response.data.status === true) {
                                            setFetchingGateways(false);
                                            return response.data.data.id;
                                        } else {
                                            const errorMsg = response?.data?.message || "Failed to create PayPal order.";
                                            toast.error(errorMsg);
                                            throw new Error(errorMsg);
                                        }
                                    } catch (error) {
                                        console.error("Create Order Error:", error);
                                        setFetchingGateways(false);
                                        throw error;
                                    }
                                }}
                                onApprove={async (data) => {
                                    setFetchingGateways(true);
                                    try {
                                        const response = await postMasterToken("paypal/capture-order", {
                                            paypal_order_id: data.orderID,
                                            order_id: invoiceDetail?.order_id,
                                        });
                                        if (response && response.status === 200 && response.data.status === true) {
                                            toast.success(response.data.message || "Payment completed successfully!");
                                            getInvoiceData();
                                            setModal(false);
                                            navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
                                        } else {
                                            console.error("Capture Error:", response);
                                            toast.error(response?.data?.message || "Payment verification failed.");
                                        }
                                    } catch (error) {
                                        console.error("Capture Error:", error);
                                        toast.error("Payment verification failed.");
                                    } finally {
                                        setFetchingGateways(false);
                                    }
                                }}
                                onCancel={() => {
                                    toast.info("Payment cancelled.");
                                }}
                                onError={(err) => {
                                    console.error("PayPal Error:", err);
                                    toast.error("PayPal checkout error.");
                                }}
                            />
                        </div>
                    ) : (
                        <div className="pay-now-btn-container">
                            <button className="pay-now-primary-btn" onClick={handleRazorpayPayment}>
                                Pay {invoiceDetail.currency || '$'} {invoiceDetail.order_total}
                            </button>
                        </div>
                    )}

                    <div className="secure-payment-footer mt-3">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                        <span>Payments are safe and secure</span>
                    </div>
                </div>
            </Popup>
        </Fragment>
    );
};

export default PrintComponent;